import styled, { css } from 'styled-components';

import { device, hexToRGB } from '@/styles/helpers';

export interface ScSwitchButtonProps {
  isChecked: boolean;
  animated?: boolean;
}

export const ScSwitchButton = styled.label<ScSwitchButtonProps>`
  display: flex;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
  width: 52px;
  height: 28px;
  background: ${({ theme }) => theme.color20};
  border-radius: 20px;

  &:hover .slider::after {
    background: ${({ theme, isChecked }) =>
      isChecked ? hexToRGB(theme.color22, 0.4) : hexToRGB(theme.color23, 0.4)};

    @media (${device.mobile}) {
      background: ${({ theme, isChecked }) =>
        isChecked ? theme.color22 : theme.color23};
    }
  }

  &:before,
  &:after {
    position: absolute;
    transition: all 0.4s ease-in-out;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-transform: uppercase;
    pointer-events: none;
    min-width: 20px;
    color: ${({ theme }) => hexToRGB(theme.white, 0.9)};
  }

  &:after {
    content: attr(data-unchecked);
    right: 4px;
    opacity: 1;
    justify-content: end;
  }

  &:before {
    content: attr(data-checked);
    left: 4px;
    opacity: 0;
  }

  input[type='checkbox'] {
    display: none;
  }

  .slider {
    position: relative;
    width: 100%;
    height: 100%;
    display: inline-block;
    transition: 0.3s all ease-in-out;

    &:after {
      content: '';
      position: absolute;
      top: 4px;
      width: 20px;
      height: 20px;
      display: inline-block;
      background: ${({ theme, isChecked }) =>
        isChecked ? theme.color22 : theme.color23};
      border-radius: 50%;
      transform: translateX(calc(((28px - 20px) / 2)));
      transition: 0.3s all ease-in-out;
    }
  }

  ${({ isChecked }) =>
    isChecked &&
    css`
      background: ${({ theme }) => theme.color24};

      &::after {
        opacity: 0;
      }

      &::before {
        opacity: 1;
      }

      .slider {
        &:after {
          transform: translateX(calc(52px - 20px - ((28px - 20px) / 2)));
        }
      }
    `}
`;
